import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntDocumentationCenterIcon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props}>
      <path
        d="M14 16H4C2.89543 16 2 15.1046 2 14V1C2 0.447715 2.44772 1.61064e-08 3 0H14V16ZM3 14C3 14.5523 3.44772 15 4 15H13V1H3V14Z"
        fill="currentColor"
      />
      <path
        d="M4 1H14V14H4.5C4.22386 14 4 13.7761 4 13.5V1Z"
        fill="currentColor"
      />
      <path
        d="M7.46421 8.28742V7.89536C7.46421 7.55629 7.53832 7.26137 7.68655 7.0106C7.83478 6.75982 8.10593 6.49316 8.5 6.2106C8.87961 5.9457 9.12907 5.73024 9.24837 5.56424C9.37129 5.39823 9.43275 5.2128 9.43275 5.00795C9.43275 4.77837 9.34599 4.60353 9.17245 4.48344C8.99892 4.36336 8.75669 4.30331 8.44577 4.30331C7.90347 4.30331 7.28525 4.47638 6.59111 4.82252L6 3.66225C6.80622 3.22075 7.66124 3 8.56508 3C9.30983 3 9.90094 3.17483 10.3384 3.5245C10.7795 3.87417 11 4.3404 11 4.92318C11 5.3117 10.9096 5.64724 10.7289 5.9298C10.5481 6.21236 10.2046 6.53024 9.69848 6.88344C9.35141 7.13422 9.13087 7.32494 9.03688 7.45563C8.94649 7.58631 8.9013 7.75762 8.9013 7.96954V8.28742H7.46421ZM7.29067 10.0993C7.29067 9.80265 7.37202 9.57837 7.53471 9.42649C7.6974 9.27461 7.9342 9.19868 8.24512 9.19868C8.54519 9.19868 8.77657 9.27638 8.93926 9.43179C9.10557 9.5872 9.18872 9.80971 9.18872 10.0993C9.18872 10.3784 9.10557 10.5991 8.93926 10.7616C8.77296 10.9205 8.54158 11 8.24512 11C7.94143 11 7.70644 10.9223 7.54013 10.7669C7.37383 10.6079 7.29067 10.3854 7.29067 10.0993Z"
        fill="white"
      />
    </SntIcon>
  );
};

export default SntDocumentationCenterIcon;
